import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
  }

  /**
   * Fetches prescription templates from the backend database.
   * Supports optional parameters to filter templates by starting alphabet or search query on the server side.
   *
   * @param alphabet Optional letter to filter template names starting with (e.g., 'A')
   * @param search Optional search term to filter template names or contents
   */
  getTemplates(alphabet?: string, search?: string) {
    let params: any = {};
    if (alphabet) {
      params.alphabet = alphabet;
    }
    if (search) {
      params.search = search;
    }
    const authHeaders = this.getAuthHeaders();
    return this.http.get(this.apiUrl + '/template', {
      headers: authHeaders.headers,
      params: params
    });
  }

  addTemplate(payload: any) {
    return this.http.post(this.apiUrl + '/template', payload, this.getAuthHeaders());
  }

  updateTemplate(payload: any) {
    return this.http.put(this.apiUrl + '/template/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteTemplate(templateId: number) {
    return this.http.delete(this.apiUrl + '/template/' + templateId, this.getAuthHeaders());
  }

  getTemplateById(templateId: number) {
    return this.http.get(this.apiUrl + '/template/' + templateId, this.getAuthHeaders());
  }
}
